import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "register-candidates",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "register-candidates" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
